import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CustomButton from "../../Components/CustomButton";
import { axiosAPI } from "../../Axios/Axios";
import { errorNotify, succesNotify } from "../../CommonCode/Commonfunc";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

export default function DeleteComment({ open, handleClose, commentId }) {
  //   const redirect = useNavigate();
  const Labels = useSelector((state) => state.allLabels.labels);
  const [btndisable, setbtndisable] = React.useState(false);

  const deleteComment = async () => {
    setbtndisable(true);

    if (commentId) {
      try {
        const postData = {
          gmh_id: commentId,
          type: "group",
          language:localStorage.getItem("language")
        };
        const result = await axiosAPI.post("/deleteComment", postData);
        const { status, message } = result.data;
        if (status) {
          succesNotify(message);
          setbtndisable(false);
          handleClose();
        } else {
          errorNotify(message);
          setbtndisable(false);
        }
      } catch (error) {
        //// console.log(error.message);
        setbtndisable(false);
      }
    } else {
      //// console.log(" Comment id is not available to delete group");
      setbtndisable(false);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          minWidth: "300px",
          padding: "20px",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
        {Labels?.areYouSure}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ textAlign: "center", fontFamily: "poppins" }}
        >
          {Labels?.wantToDelete}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ justifyContent: "center", marginTop: "20px" }}>
        <CustomButton
          label={Labels?.delete}
          style={{
            width: 100,
            borderRadius: "3px",
            fontSize: "14px",
            mb: 2,
          }}
          disabled={btndisable}
          onClick={deleteComment}
        />
        <CustomButton
          label={Labels?.Cancel}
          style={{
            width: 100,
            borderRadius: "3px",
            fontSize: "14px",
            mb: 2,
          }}
          onClick={handleClose}
        />
      </DialogActions>
    </Dialog>
  );
}
